import { useEffect, useState } from 'react';

export function useNarrowViewport(breakpointPx: number): boolean {
  const query = `(max-width: ${breakpointPx - 1}px)`;
  const [isNarrow, setIsNarrow] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const handler = (e: MediaQueryListEvent) => setIsNarrow(e.matches);
    setIsNarrow(mql.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, [query]);

  return isNarrow;
}
